import { useNavigate } from "@solidjs/router";
import { StButton } from "@storytell/ui/buttons";
import { Show } from "solid-js";
import { Logo } from "~/components/brand";
import { useWire } from "~/wire";

export default function NotFound() {
  const wire = useWire();
  const navigate = useNavigate();

  // Check if user is a guest (not logged in)
  const isGuest = () => wire.auth.isGuest();

  return (
    <main class="min-h-screen bg-panel flex flex-col items-center px-4 pt-[33vh]">
      <Show
        when={isGuest()}
        fallback={
          <div class="text-center">
            <p class="text-gray-700 dark:text-gray-300 text-lg">Not Found</p>
          </div>
        }
      >
        <div class="flex flex-col items-center max-w-md">
          <div class="mb-8">
            <Logo size={150} />
          </div>
          <p class="text-lg font-medium text-primary-text mb-6 text-center">
            You need to be signed in to access this link.
          </p>
          <div class="flex items-center justify-center gap-2">
            <StButton
              onClick={() => navigate("/auth/signup")}
              class="px-6 py-2 bg-brand hover:bg-brand-hover text-on-brand font-medium rounded-lg"
            >
              Sign up
            </StButton>
            <span class="text-secondary-text">or</span>
            <a
              href="/auth/login"
              onClick={(e) => {
                e.preventDefault();
                navigate("/auth/login");
              }}
              class="text-brand hover:text-brand-hover underline font-medium"
            >
              Log In
            </a>
          </div>
        </div>
      </Show>
    </main>
  );
}
